import $decks from 'app/stores/decks/$decks';
import { GRID_MARGIN, GRID_ROW_HEIGHT } from 'app/stores/boards/constants';

export function getWidgetFields(name) {
  if (name) {
    const config = $decks.widgets[name];
    const fields = config?.Component?.fields;
    if (fields) {
      return Object.fromEntries(
        Object.entries(fields)
          .filter(([fieldName]) => fieldName !== 'title')
          .map(([fieldName, fieldConfig]) => [
            `config.${fieldName}`,
            typeof fieldConfig === 'function' ? fieldConfig() : fieldConfig
          ])
      );
    }
  }

  return {};
}

export function getWidgetTitle(config = {}) {
  if (config.widgetName) {
    const widgetConfig = $decks.widgets[config.widgetName];
    if (widgetConfig?.Component?.getDefaultTitle) {
      return widgetConfig.Component.getDefaultTitle(config);
    }
    if (widgetConfig?.title) {
      return widgetConfig.title;
    }
  }
  return undefined;
}

export function getWidgetLayout(name) {
  return $decks.widgets[name]?.layoutDefaults;
}

export function getWidgetSize(name) {
  const { w = 12, h = 12, minW = 4 } = getWidgetLayout(name)?.lg || {};
  const minWidth = `min(calc(100vw * ${minW / 12}), 100%)`;
  const maxWidth = `min(calc(100vw * ${w / 12}), 100%)`;
  const maxHeight = h * GRID_ROW_HEIGHT + (h - 1) * GRID_MARGIN;
  return { width: '100%', minWidth, maxWidth, maxHeight, alignSelf: 'center' };
}
